export default __webpack_public_path__ + "static/media/sms-notification.620acd22.svg";